import { Box, Grid } from '@chakra-ui/react';

export function FormStepsBar({
  totalSteps,
  currentStep,
  activeColor,
  nonActiveColor,
}: {
  totalSteps: number;
  currentStep: number;
  activeColor?: string;
  nonActiveColor?: string;
}) {
  return (
    <Grid
      css={{
        borderRadius: 'base',
        overflow: 'hidden',
        gridTemplateColumns: `repeat(${totalSteps}, 1fr)`,
        height: 1,
        gap: 2,
      }}
    >
      {Array.from(Array(totalSteps).keys()).map((_, i) => (
        <Box
          key={i}
          height={1}
          bg={
            i < currentStep ? activeColor || 'green.500' : nonActiveColor || 'backgroundSecondary'
          }
        />
      ))}
    </Grid>
  );
}
